import axios from 'axios'
import showToastify from '../utils/toastify'
import 'toastify-js/src/toastify.css'
import { find } from 'utils/dom'
import IMask from 'imask';

export default function contatoForm() {
    const page1 = find("[js-page='home']");
    const page2 = find("[js-page='contato']");

		var phoneMask = IMask(
			document.getElementById('telefone'),
			{
				mask: '(00) 00000-0000'
			}
		);
	
    function showMessage(response) {
        const message = response.data ? response.data.message : response.message
        showToastify(message)
        contatoFormSubmit.reset()
        setTimeout(enabledBtn, 1000)
    }

    const btnSubmit = document.querySelector('#form-contato button[type=submit]')

    function disabledBtn() {
        btnSubmit.disabled = true
        btnSubmit.classList.add('disabled')
    }

    function enabledBtn() {
        btnSubmit.disabled = false
        btnSubmit.classList.remove('disabled')
    }


    const contatoFormSubmit = document.querySelector('#form-contato');

    contatoFormSubmit &&
        contatoFormSubmit.addEventListener('submit', function (event) {
            event.preventDefault()
            disabledBtn()

            const formData = new FormData()
            formData.append('nome', document.querySelector('#form-contato  input[name=nome]').value)
            formData.append('email', document.querySelector('#form-contato  input[name=email]').value)
            formData.append('telefone',phoneMask.value)
            formData.append('mensagem', document.querySelector('#form-contato  textarea[name=mensagem]').value)

						const formObject = {};
							formData.forEach((value, key) => {
									formObject[key] = value;
							});

            const url = '/contato_send/'

            axios
                .post(url, formObject)
                .then((response) => showMessage(response))
                .catch((response) => showMessage(response))
        })

}